export const getMaterials = (apiClient) => {
    return {
        async fetch(ids) {
            const res = await apiClient.request('/calculator/materials', { ids });
            return res;
        }
    };
};
